import React from 'react';
import styled from 'styled-components';
import Heading from 'components/atoms/Heading/Heading';
import Paragraph from 'components/atoms/Paragraph/Paragraph';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { IconButton } from '@mui/material';
import { theme } from 'theme/MainTheme';

const LogsWrapper = styled.div`
  width: 100%;
  height: calc(100vh - 70px);
  padding: 30px;
`;

const Log = styled.div`
  height: 3vh;
  display: flex;
  align-items: center;
`;

const LogTitle = styled.div`
  padding-left: 20px;
`;

const LogDate = styled.div`
  font-size: ${theme.fontSize.xs};
`;

const StyledParagraph = styled(Paragraph)`
  font-weight: ${theme.bold};
  padding-top: 2rem;
  color: ${theme.primary};
`;

const logsData = [
  { log_title: 'Import plików', log_file_title: 'import_plikow.txt', log_date: '2022-12-12' },
  {
    log_title: 'Import użytkowników',
    log_file_title: 'import_uzytkownikow.txt',
    log_date: '2022-12-18',
  },
  { log_title: 'Wysyłka maili', log_file_title: 'wysylka_maili.txt', log_date: '2022-11-10' },
];

const AdminLogs = () => (
  <LogsWrapper>
    <Heading>Logi</Heading>
    {logsData.map((elem) => (
      <div>
        <StyledParagraph>{elem.log_title}</StyledParagraph>
        <Log>
          <IconButton edge="end" aria-label="download">
            <FileDownloadIcon fontSize="large" />
          </IconButton>
          <LogTitle>{elem.log_file_title}</LogTitle>
        </Log>
        <LogDate>Data przesłania pliku: {elem.log_date}</LogDate>
      </div>
    ))}
  </LogsWrapper>
);

export default AdminLogs;
